var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 16 17",
    fill: "contentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 8.80108C13.8951 9.93588 13.4692 11.0174 12.7721 11.9189C12.075 12.8205 11.1356 13.5049 10.0637 13.8921C8.99188 14.2793 7.83192 14.3532 6.7196 14.1051C5.60728 13.8571 4.5886 13.2974 3.78275 12.4916C2.97691 11.6858 2.41723 10.6671 2.16921 9.55475C1.92118 8.44242 1.99508 7.28247 2.38224 6.21061C2.7694 5.13875 3.45382 4.19932 4.35541 3.50225C5.257 2.80517 6.33847 2.37928 7.47327 2.27441C6.80888 3.17326 6.48917 4.28071 6.57229 5.39536C6.65541 6.51 7.13584 7.55779 7.9262 8.34815C8.71656 9.13851 9.76435 9.61894 10.879 9.70206C11.9936 9.78518 13.1011 9.46547 13.9999 8.80108Z",
    stroke: "contentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.93489e421b7e611d782e39f07154b5b0.svg";
export { ForwardRef as ReactComponent };